/**
 * Formats a number of seconds as a narrow localized duration, such as "1h 2m 3s".
 */
/**
 * Formats a number of minutes as hours and minutes, such as "1h 30m" or "45m".
 */
export function formatMinutesToDuration(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
}
/**
 * Formats a number of seconds as a media timestamp, such as "1:02" or "1:02:05". Rounds fractional seconds down.
 */
export function formatTimestamp(secondsInput) {
    const totalSeconds = Math.floor(secondsInput);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    if (h > 0) {
        return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
    return `${m}:${String(s).padStart(2, '0')}`;
}
//# sourceMappingURL=duration.js.map